export default __webpack_public_path__ + "static/media/denied.e540ac81.gif";